/* eslint-disable import/first */
import React, { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const DragZone = (props) => {
  const {
    imgSrc,
    icon,
    label,
    className,
    acceptedFiles = "application/pdf",
    maxSize = 25000000,
    multiple = false,
    noClick,
    version = 1,
    handleFile,
    maxFiles = 1,
    onDrop,
    onDropRejected,
  } = props;
  const { t } = useTranslation();
  const { getRootProps, getInputProps, open } = useDropzone({
    accept: acceptedFiles,
    maxSize: maxSize,
    onDrop : onDrop || handleFile,
    noClick,
    multiple: multiple,
    noKeyboard: true,
    maxFiles,
    onDropRejected
  });

  return (
    <React.Fragment>
      <div className="text-muted d-flex justify-content-between">
        <div>
            {t('common.maxFiles', { maxFiles, count: maxFiles })}
        </div>
        <div>
            {t('common.maxSizePerFile', { maxSizeInMb: maxSize/1_000_000 })}
          </div>
        </div>
      <div className={clsx(`DragZone_Container`, className, `v${version}`)} {...getRootProps({})}>
        <input {...getInputProps()} />
        <div className="DragZone_Inner_Container">
          { !icon && imgSrc && <img className="DragZone_Image" src={imgSrc} alt={label} /> }
          { icon && !imgSrc && <i className={`DragZone_Icon fas fa-${icon}`} /> }
          <p className="DragZone_Photo_Label text-center">{label}</p>
        </div>
      </div>
    </React.Fragment>
  );
};
export default DragZone;
